var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2903_180647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7044 15.7064C12.5169 15.8938 12.2626 15.9992 11.9974 15.9992C11.7322 15.9992 11.4779 15.8938 11.2904 15.7064L5.63341 10.0494C5.5379 9.95712 5.46172 9.84678 5.40931 9.72477C5.3569 9.60277 5.32932 9.47155 5.32816 9.33877C5.32701 9.20599 5.35231 9.07431 5.40259 8.95141C5.45287 8.82852 5.52713 8.71686 5.62102 8.62297C5.71491 8.52908 5.82656 8.45483 5.94946 8.40454C6.07236 8.35426 6.20404 8.32896 6.33681 8.33012C6.46959 8.33127 6.60081 8.35886 6.72282 8.41126C6.84482 8.46367 6.95517 8.53986 7.04741 8.63537L11.9974 13.5854L16.9474 8.63537C17.136 8.45321 17.3886 8.35241 17.6508 8.35469C17.913 8.35697 18.1638 8.46214 18.3492 8.64755C18.5346 8.83296 18.6398 9.08377 18.6421 9.34597C18.6444 9.60816 18.5436 9.86076 18.3614 10.0494L12.7044 15.7064Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2903_180647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.83e7a59a6a8b91e394e1d7cca9425d29.svg";
export { ForwardRef as ReactComponent };